import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, firstValueFrom } from 'rxjs';
import { Router } from '@angular/router';
import { ConfigService } from './config.service';
import { DeathReport } from '../models/death-report';

@Injectable({
  providedIn: 'root'
})
export class DeathReportService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly configService: ConfigService,
    private readonly router: Router
  ) {}

  private readonly apiUrl = this.configService.get('WriteOffApiUrl');

  async getDeathReports(): Promise<DeathReport[]> {
    return await firstValueFrom(this.httpClient.get<DeathReport[]>(`${this.apiUrl}/death-report`)) ?? [];
  }

  getDeathReportWriteoffs(id: string): Observable<DeathReport> {
    return this.httpClient.get<DeathReport>(`${this.apiUrl}/death-report/${id}`);
  }

  async createDeathReport(startDate: string, endDate: string): Promise<void> {
    const postData = { startDate, endDate, type: 'DEATH' };
    const result: any = await firstValueFrom(
      this.httpClient.post(`${this.apiUrl}/death-report`, postData)
    );
    this.router.navigate(['/death-report', result['id']]);
  }
}
